import React, { useRef, useState } from "react";
import { Stack } from "@mui/material";
import Tooltip from "@hyro-components/Tooltip";
import AdminHyroLogo from "../../Logos/AdminHyroLogo";
import DashboardHyroLogo from "../../Logos/DashboardHyroLogo";
import { StyledButton, StyledDivider } from "../HeaderStyles";
import AccountsMenu from "../AccountsMenu";
import WandIcon from "../../../icons/WandIcon";
import UserMenu from "../UserMenu";
import { useIsAdminPanel, useIsMobile } from "@hooks";
import PreviewManager from "../preview/PreviewManager";
import useAppStore from "../../../stores/appStore";
import { setSystemModeSelector, assistantIdSelector } from "../../../stores/selectors/appSelectors";
import { setInfoPopoversSelector, infoPopoversSelector } from "src/stores/selectors/tripletsSelectors";
import { SYSTEM_MODES } from "../../../stores/slices/createAppSlice";
import NotificationDotIcon from "src/icons/NotificationDotIcon";
import styled from "@emotion/styled";
import { useDraft } from "src/queries/hooks/assistants";
import InfoPopover from "./status-header/DraftPublishing/InfoPopover";
import { DONT_SHOW_AGAIN_STORAGE, POPOVERS } from "./status-header/DraftPublishing/DraftHeaderConsts";
import DevBanner from "src/layout/Header/header-types/dev-banner/DevBanner";
import { previewLiveBuildResponseSelector } from "src/stores/selectors/previewSelectors";
import { BUILD_STATUSES } from "@consts";
import NotificationContainer from "src/components/widgets/notifications/notifications-container/NotificationsContainer";
import useBuildStatusSocket from "src/layout/Header/preview/useBuildStatusSocket";

const IconWrapper = styled("span")`
  position: absolute;
  top: -7px;
  right: -7px;
`;

const ReadOnlyModeHeader = ({ selectedAssistant }) => {
  const isAdminPanel = useIsAdminPanel();
  const setSystemMode = useAppStore(setSystemModeSelector);
  const assistantId = useAppStore(assistantIdSelector);
  const infoPopovers = useAppStore(infoPopoversSelector);
  const setInfoPopovers = useAppStore(setInfoPopoversSelector);
  const previewBuildResponse = useAppStore(previewLiveBuildResponseSelector);
  const isMobile = useIsMobile();
  const { data: draft } = useDraft();
  const getValidationResults = useAppStore(state => state.getValidationResults);
  const previewButtonRef = useRef(null);

  useBuildStatusSocket(!!assistantId, { isLivePreview: true });

  const [dontShowPopovers, setDontShowPopovers] = useState(() => ({
    preparePreview: localStorage.getItem(DONT_SHOW_AGAIN_STORAGE.PREPARE_PREVIEW)
  }));

  const handleEditModeClick = () => {
    setSystemMode(SYSTEM_MODES.EDIT);

    if (draft) {
      getValidationResults();
    }
  };

  const handleGotIt = (type, checked) => {
    if (checked) {
      localStorage.setItem(type, "true");
      setDontShowPopovers(prev => ({ ...prev, [type]: "true" }));
    }
    setInfoPopovers(type, false);
  };

  return <>
    <Stack direction='row'>
      {isAdminPanel ? <AdminHyroLogo /> : <DashboardHyroLogo />}
      <StyledDivider orientation="vertical" flexItem />
      <AccountsMenu />
      <DevBanner />
      <Stack direction='row' sx={{ ml: "auto" }} alignItems={"center"} justifyContent='center' gap={1}>
        {selectedAssistant && !isMobile ?
          <>
            <PreviewManager ref={previewButtonRef} />
            <Tooltip
              title={draft ? "Unpublished changes pending" : ""}
              placement="bottom">
              <StyledButton
                data-testid={"edit-mode-button"}
                onClick={handleEditModeClick}
                variant="outlined"
                startIcon={<WandIcon />}>
                Edit mode
                {!!draft && <IconWrapper><NotificationDotIcon /></IconWrapper>}
              </StyledButton>
            </Tooltip>

            <NotificationContainer />
          </>
          : null}
        <UserMenu />
      </Stack>

      <InfoPopover
        open={previewBuildResponse?.status === BUILD_STATUSES.PENDING && infoPopovers.preparePreview && !dontShowPopovers.preparePreview}
        data={POPOVERS.PREPARE_PREVIEW}
        anchorRef={previewButtonRef}
        onGotIt={(checked) => handleGotIt(DONT_SHOW_AGAIN_STORAGE.PREPARE_PREVIEW, checked)} />
    </Stack>
  </>;
};

export default ReadOnlyModeHeader;
